<card-component>
  <card-title [title]="title" [image]="image"></card-title>
  <card-content>
    <div [innerHTML]="description" class="item-description"></div>
  </card-content>
  <card-actions>
    <div>
      @for (action of actions; track actionTracker($index)) {
        <list-item-action
          [item]="item"
          [itemAction]="action"
        ></list-item-action>
      }
    </div>
    @if (deleteSelection) {
      <div [ngStyle]="{ float: 'right' }">
        <table-cell-checkbox
          [instance]="item"
          [selection]="deleteSelection"
          (handleToggle)="handleToggle($event)"
        ></table-cell-checkbox>
      </div>
    }
  </card-actions>
</card-component>
